<template>
  <sh-doc-card content-path="/privacy.html"/>
</template>

<script>
    import DocCard from "../../components/common/DocCard";
    export default {
        name : 'App',
        props : {
            content_path : String,
        },
        components : {
            "sh-doc-card" : DocCard
        },
    }
</script>

<style lang="sass">
  @import "../../styles/style"

  .panel-group p
    font-size: 14px

  .panel-group h5
    margin-bottom: 10px

  .panel-default
    white-space: normal
    margin-bottom: 10px
    border-color: #ddd !important
    border-radius: 4px
    box-shadow: 0 1px 1px rgba(0,0,0,.05)
    background-color: white

  .panel
    border: 1px solid transparent
    box-shadow: 0 1px 1px rgba(0,0,0,.05)

  .panel-heading
    color: #333
    background-color: #f5f5f5
    border-color: #ddd

  .panel-title
    margin-top: 0 !important
    margin-bottom: 0 !important
    font-size: 16px !important

  .panel-title a
    display: block
    padding: 20px 15px
    text-decoration: none !important
    color: $text-black !important

  .panel-body
    padding: 15px
    border-top: 1px solid #ddd
</style>
